var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{key:`toast1-${+new Date()}`,attrs:{"name":"toast-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],key:`toast-${+new Date()}`,staticClass:"toast",on:{"click":function($event){_vm.visible = false}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }